module.exports = __webpack_public_path__ + "media/assets/images/cloudy-cc254c65cdeb523d6d5b5f84657a8334.png";